export function sanitizeMarkdownHref(href) {
    if (!href)
        return null;
    const trimmed = href.trim();
    if (!trimmed)
        return null;
    try {
        const parsed = new URL(trimmed);
        if (parsed.protocol === "http:" || parsed.protocol === "https:")
            return parsed.href;
    }
    catch {
        return null;
    }
    return null;
}
